var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4103 3.49946H9.31392V2.16016H17.4103C18.2733 2.16016 18.9728 2.85972 18.9728 3.72267V13.5442C18.9728 14.4072 18.2733 15.1067 17.4103 15.1067H13.1552L8.22406 18.5206C7.48384 19.033 6.47269 18.5032 6.47269 17.6029V15.1067H4.91017C4.04722 15.1067 3.34766 14.4072 3.34766 13.5442V7.04764H4.68696V13.5442C4.68696 13.6675 4.78689 13.7674 4.91017 13.7674H7.81199V17.1769L12.7368 13.7674H17.4103C17.5336 13.7674 17.6335 13.6675 17.6335 13.5442V3.72267C17.6335 3.59939 17.5336 3.49946 17.4103 3.49946Z",
    fill: "#8A939A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9604 8.39008H7.58594V7.05078H14.9604V8.39008Z",
    fill: "#8A939A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48047 8.49744V6.94531H15.0677V8.49744H7.48047ZM14.9613 8.39103H7.58688V7.05173H14.9613V8.39103Z",
    fill: "#8A939A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9431 11.3588H7.58594V10.0195H12.9431V11.3588Z",
    fill: "#8A939A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48047 11.4662V9.91406H13.0505V11.4662H7.48047ZM12.9441 11.3598H7.58688V10.0205H12.9441V11.3598Z",
    fill: "#8A939A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37216 5.15262V5.27762H6.49716H7.30296H7.42796V5.15262V4.46647C7.42796 3.87611 7.21854 3.36915 6.80234 2.95266L6.80228 2.9526C6.3858 2.5364 5.87883 2.32698 5.28847 2.32698H2.11795L3.35499 1.08994L3.44338 1.00156L3.35499 0.913167L2.79094 0.349112L2.70255 0.260723L2.61416 0.349112L0.196777 2.76649L0.108389 2.85488L0.196777 2.94327L2.61416 5.36065L2.70255 5.44904L2.79094 5.36065L3.35499 4.7966L3.44338 4.70821L3.35499 4.61982L2.11795 3.38278H5.28847C5.59145 3.38278 5.84493 3.48739 6.05624 3.6987C6.26756 3.91002 6.37216 4.1635 6.37216 4.46647V5.15262Z",
    fill: "#8A939A",
    stroke: "#8A939A",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReply);
export default __webpack_public_path__ + "static/media/message-reply.66adf765c2187364c9689e84076d0b61.svg";
export { ForwardRef as ReactComponent };